import { useSharedDataPrivacyApi } from '@/features/api/hooks/shared-data-privacy/useSharedDataPrivacyApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useDeletePerson = () => {
  const api = useSharedDataPrivacyApi();
  const { logout } = useAuth();

  return useApiMutation<void, unknown, void>({
    mutationFn: () => api.deletePerson(),
    onSuccess: logout
  });
};
